import { render, staticRenderFns } from "./HeadersTab.vue?vue&type=template&id=cc9668fe&"
import script from "./HeadersTab.vue?vue&type=script&lang=js&"
export * from "./HeadersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports